module.exports = __webpack_public_path__ + "media/mining_bg.489fa3d9.mp3";